// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W4sqn","label":"styles_label__2XXUi"};